export enum CategorySortKeyEnum {
  DISPLAY_ORDER = 'displayOrder',
}

export enum DictionarySectionEnum {
  CATEGORIES = 'CATEGORIES',
  POSITIONS = 'POSITIONS',
  PROCEDURE_NAMES = 'PROCEDURE_NAMES',
  TAGS = 'TAGS',
}

export enum DictionaryStatusFilterEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PositionSortKeyEnum {
  NAME = 'name',
  QUESTION_COUNT = 'questionCount',
}

export enum ProcedureNameSortKeyEnum {
  USAGE = 'usage',
}

export enum TagSortKeyEnum {
  LABEL = 'label',
  QUESTION_COUNT = 'questionCount',
}
